import type { MediaItem } from "@/mocks/media";
import MediaCard from "@/components/feature/MediaCard";
import SectionHeading from "@/components/feature/SectionHeading";

interface MediaGridSectionProps {
  title: string;
  subtitle?: string;
  icon?: string;
  moreTo: string;
  items: MediaItem[];
}

export default function MediaGridSection({
  title,
  subtitle,
  icon,
  moreTo,
  items,
}: MediaGridSectionProps) {
  return (
    <section className="mx-auto max-w-[1280px] px-4 md:px-6">
      <SectionHeading title={title} subtitle={subtitle} icon={icon} moreTo={moreTo} />
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-5 lg:grid-cols-5">
        {items.map((item) => (
          <MediaCard key={item.id} item={item} />
        ))}
      </div>
    </section>
  );
}